(function(){
  const L = window.Lucern || {};
  const S = L.strings || {};
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  /* run fn at most once per frame, however many scroll events arrive */
  const perFrame = fn=>{ let q=0; return ()=>{ if(q) return; q=1; requestAnimationFrame(()=>{ q=0; fn(); }); }; };

  /* money */
  function money(cents){
    const fmt = L.moneyFormat || '{{amount}}';
    const n = (cents/100);
    const withDelim = (num, dec, th=',', ds='.') => {
      const p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch(k){
        case 'amount_no_decimals': return withDelim(n,0);
        case 'amount_with_comma_separator': return withDelim(n,2,'.',',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(n,0,'.',',');
        default: return withDelim(n,2);
      }
    });
  }
  L.money = money;

  function toast(msg){
    let t = $('.toast'); if(!t){ t=document.createElement('div'); t.className='toast'; t.setAttribute('role','status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-shown'); clearTimeout(t._h); t._h=setTimeout(()=>t.classList.remove('is-shown'),2600);
  }

  /* mobile nav */
  const mnav = $('#mnav');
  $$('[data-menu-open]').forEach(b=>b.addEventListener('click',()=>{ mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden','false'); b.setAttribute('aria-expanded','true'); $('a,button',mnav)?.focus(); document.body.style.overflow='hidden'; }));
  $$('[data-menu-close]').forEach(b=>b.addEventListener('click',()=>{ mnav.classList.remove('is-open'); mnav.setAttribute('aria-hidden','true'); $$('[data-menu-open]').forEach(x=>x.setAttribute('aria-expanded','false')); document.body.style.overflow=''; }));

  /* language switch */
  $$('[data-lang]').forEach(b=>b.addEventListener('click',()=>{
    const f = $('#lang-form'); if(!f) return;
    f.querySelector('[name=locale_code]').value = b.dataset.lang; f.submit();
  }));

  /* qty steppers (static forms) */
  document.addEventListener('click', e=>{
    const b = e.target.closest('[data-step]'); if(!b || b.closest('.drawer')) return;
    const i = b.parentElement.querySelector('input'); const v = Math.max(parseInt(i.min||1), (parseInt(i.value)||1) + parseInt(b.dataset.step));
    i.value = v; i.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* ---------- cart drawer ---------- */
  const drawer = $('#cart-drawer');
  let lastFocus = null;
  function openDrawer(){ if(!drawer) return; lastFocus=document.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; setTimeout(()=>$('.drawer__hd button',drawer)?.focus(),50); }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; lastFocus?.focus(); }
  $$('[data-drawer-close]').forEach(b=>b.addEventListener('click',closeDrawer));
  document.addEventListener('keydown',e=>{ if(e.key==='Escape'){ closeDrawer(); closeLB(); window.LucernCloseSearch&&window.LucernCloseSearch(); $$('[data-menu-close]')[0]?.click(); } });
  $$('[data-cart-open]').forEach(a=>a.addEventListener('click',e=>{ if(!drawer) return; e.preventDefault(); renderCart().then(openDrawer); }));

  function esc(s){ return String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  function imgSize(url, w){ if(!url) return ''; return url.replace(/(\.[a-z]+)(\?|$)/i, `_${w}x$1$2`); }

  function updateCount(n){ $$('.cart-count').forEach(c=>{ c.textContent=n; c.hidden = n===0; }); }

  async function renderCart(){
    const cart = await fetch((L.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
    updateCount(cart.item_count);
    if(!drawer) return cart;
    const body = $('.drawer__body',drawer), ft = $('.drawer__ft',drawer);
    if(!cart.items.length){
      body.innerHTML = `<div class="empty"><p>${esc(S.cartEmpty)}</p><a class="btn btn--ghost" href="${L.routes.collections}">${esc(S.continueShopping)}</a></div>`;
      ft.hidden = true; return cart;
    }
    ft.hidden = false;
    body.innerHTML = cart.items.map((it,idx)=>`
      <div class="line" data-line="${idx+1}">
        <a class="line__img" href="${it.url}">${it.image?`<img src="${imgSize(it.image,200)}" alt="${esc(it.product_title)}" width="100" height="100" loading="lazy">`:''}</a>
        <div>
          <a class="line__t" href="${it.url}">${esc(L.titles?.[it.product_id] || it.product_title)}</a>
          ${it.variant_title && !it.product_has_only_default_variant ? `<div class="line__v">${esc(it.variant_title)}</div>`:''}
          <div class="qty qty--sm" style="margin-top:8px;width:max-content">
            <button type="button" data-dstep="-1" aria-label="${esc(S.decrease)}">−</button>
            <input type="number" value="${it.quantity}" min="0" aria-label="${esc(S.quantity)}" data-dqty>
            <button type="button" data-dstep="1" aria-label="${esc(S.increase)}">+</button>
          </div>
        </div>
        <div class="price">${money(it.final_line_price)}</div>
      </div>`).join('');
    $('[data-subtotal]',ft).textContent = money(cart.total_price);
    return cart;
  }
  async function changeLine(line, qty){
    await fetch((L.routes?.root||'/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity:qty})});
    renderCart();
  }
  drawer?.addEventListener('click',e=>{
    const b = e.target.closest('[data-dstep]'); if(!b) return;
    const row = b.closest('[data-line]'); const inp = $('[data-dqty]',row);
    changeLine(+row.dataset.line, Math.max(0,(+inp.value)+(+b.dataset.dstep)));
  });
  drawer?.addEventListener('change',e=>{
    if(!e.target.matches('[data-dqty]')) return;
    changeLine(+e.target.closest('[data-line]').dataset.line, Math.max(0,+e.target.value||0));
  });

  /* cart page: auto-update qty */
  $$('form[data-cart-form] input[data-line-qty]').forEach(i=>i.addEventListener('change',()=>{ clearTimeout(i._t); i._t=setTimeout(()=>i.form.submit(),400); }));

  /* add to cart (ajax) */
  document.addEventListener('submit', async e=>{
    const f = e.target; if(!f.matches('form[data-atc]')) return;
    e.preventDefault();
    const btn = $('[type=submit]',f); const label = btn.innerHTML; btn.disabled = true; if(btn.classList.contains('qa-btn')){ btn.classList.add('is-busy'); } else { btn.textContent = S.adding; }
    try{
      const res = await fetch((L.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)});
      const data = await res.json();
      if(!res.ok){ toast(data.description || S.error); }
      else { navigator.vibrate?.(12); await renderCart(); openDrawer(); }
    }catch(err){ toast(S.error); }
    btn.disabled = false; btn.classList.remove('is-busy'); btn.innerHTML = label;
  });

  /* ---------- product page ---------- */
  const pdp = $('[data-pdp]');
  if(pdp && $('[data-product-json]',pdp) && $('form[data-atc]',pdp)){
    const data = JSON.parse($('[data-product-json]',pdp).textContent);
    const form = $('form[data-atc]',pdp);
    const idInput = $('input[name=id]',form);
    const priceEl = $('[data-price]',pdp);
    const atc = $('[data-atc-btn]',pdp);
    const stickyBtn = $('.sticky-buy .btn');
    const stickyPrice = $('[data-sticky-price]');
    const slides = $$('.gal__track > img',pdp);
    const thumbs = $$('.gal__thumbs button',pdp);
    const track = $('[data-track]',pdp);
    const prog = $$('.gal__prog i',pdp), countEl = $('[data-count]',pdp);
    const mq = matchMedia('(max-width:759px)');
    let current = 0;

    function setActive(i){
      current = i;
      slides.forEach((s,k)=>s.classList.toggle('is-active',k===current));
      thumbs.forEach((t,k)=>t.setAttribute('aria-current',k===current));
      prog.forEach((d,k)=>d.classList.toggle('is-on',k===current));
      if(countEl) countEl.textContent = current+1;
      document.dispatchEvent(new CustomEvent('lucern:slide',{detail:current}));
    }
    function show(i){
      if(!slides.length) return;
      const n = (i+slides.length)%slides.length;
      if(mq.matches && track){ slides[n].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'}); }
      setActive(n);
    }
    thumbs.forEach((t,k)=>t.addEventListener('click',()=>show(k)));
    /* mobile: native swipe track */
    if(track && 'IntersectionObserver' in window){
      const io = new IntersectionObserver(es=>es.forEach(en=>{ if(en.isIntersecting && mq.matches){ const k = slides.indexOf(en.target); if(k>-1 && k!==current) setActive(k); } }),{root:track,threshold:.6});
      slides.forEach(s=>io.observe(s));
    }
    const main = $('.gal__main',pdp);
    /* desktop: swipe with trackpad-less touch (tablets) */
    let sx=null;
    main?.addEventListener('touchstart',e=>{ if(mq.matches) return; sx=e.touches[0].clientX},{passive:true});
    main?.addEventListener('touchend',e=>{ if(mq.matches || sx===null) return; const dx=e.changedTouches[0].clientX-sx; const rtl=document.dir==='rtl'; if(Math.abs(dx)>40){ show(current + ((dx<0) !== rtl ? 1 : -1)); main._swiped=true; setTimeout(()=>main._swiped=false,50);} sx=null; });
    main?.addEventListener('click',e=>{ if(e.target.closest('.hs__pt')) return; if(!main._swiped && slides.length) openLB(current); });
    main?.addEventListener('keydown',e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); openLB(current);} });

    function selected(){ return $$('.opt',pdp).map(fs=>$('input:checked',fs)?.value); }
    function update(){
      const sel = selected();
      const v = data.variants.find(v=>v.options.every((o,i)=>o===sel[i]));
      // availability marks
      $$('.opt',pdp).forEach((fs,oi)=>{
        $$('input',fs).forEach(inp=>{
          const probe = sel.slice(); probe[oi]=inp.value;
          const m = data.variants.find(v=>v.options.every((o,i)=>o===probe[i]));
          inp.classList.toggle('is-unavail', !m || !m.available);
        });
        const out = $('[data-opt-val]',fs); if(out) out.textContent = sel[oi];
      });
      if(!v){ atc.disabled=true; atc.textContent=S.unavailable; if(stickyBtn){stickyBtn.disabled=true;} return; }
      idInput.value = v.id;
      priceEl.innerHTML = (v.compare_at_price>v.price?`<s>${money(v.compare_at_price)}</s>`:'') + `<span>${money(v.price)}</span>`;
      if(stickyPrice) stickyPrice.textContent = money(v.price);
      atc.disabled = !v.available; atc.textContent = v.available ? S.addToCart : S.soldOut;
      if(stickyBtn){ stickyBtn.disabled=!v.available; }
      if(v.featured_media){ const k = slides.findIndex(s=>+s.dataset.mediaId===v.featured_media.id); if(k>-1) show(k); }
      const u = new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(null,'',u);
      document.dispatchEvent(new CustomEvent('lucern:variant',{detail:v}));
    }
    $$('.opt input',pdp).forEach(i=>i.addEventListener('change',update));
    if($$('.opt',pdp).length) update();

    /* sticky buy bar */
    const sb = $('.sticky-buy');
    if(sb && atc && 'IntersectionObserver' in window){
      new IntersectionObserver(([en])=>sb.classList.toggle('is-shown', !en.isIntersecting && en.boundingClientRect.top<0)).observe(atc);
      stickyBtn?.addEventListener('click',()=>form.requestSubmit ? form.requestSubmit() : atc.click());
    }

    /* lightbox */
    const lb = $('#lb');
    const stage = lb && $('.lb__stage',lb), lbImg = lb && $('img',stage), cnt = lb && $('.lb__count',lb);
    let li = 0;
    window.openLB = openLB;
    function setLB(i){ li=(i+slides.length)%slides.length; const s=slides[li]; lbImg.src = s.dataset.zoom; lbImg.alt = s.alt; stage.classList.remove('is-zoomed'); if(cnt) cnt.textContent=`${li+1} / ${slides.length}`; }
    function openLB(i){ if(!lb) return; setLB(i); lb.classList.add('is-open'); lb.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; $('.lb__close',lb).focus(); }
    stage?.addEventListener('click',e=>{
      if(stage.classList.contains('is-zoomed')){ stage.classList.remove('is-zoomed'); return; }
      const r = stage.getBoundingClientRect();
      lbImg.style.setProperty('--ox', ((e.clientX-r.left)/r.width*100)+'%');
      lbImg.style.setProperty('--oy', ((e.clientY-r.top)/r.height*100)+'%');
      stage.classList.add('is-zoomed');
    });
    stage?.addEventListener('mousemove',e=>{
      if(!stage.classList.contains('is-zoomed') || matchMedia('(hover:none)').matches) return;
      const r = stage.getBoundingClientRect();
      lbImg.style.setProperty('--ox', ((e.clientX-r.left)/r.width*100)+'%');
      lbImg.style.setProperty('--oy', ((e.clientY-r.top)/r.height*100)+'%');
    });
    lb && $('.lb__prev',lb)?.addEventListener('click',()=>setLB(li-1));
    lb && $('.lb__next',lb)?.addEventListener('click',()=>setLB(li+1));
    lb && $('.lb__close',lb)?.addEventListener('click',closeLB);
    document.addEventListener('keydown',e=>{ if(!lb?.classList.contains('is-open')) return; const rtl=document.dir==='rtl'; if(e.key==='ArrowRight') setLB(li+(rtl?-1:1)); if(e.key==='ArrowLeft') setLB(li+(rtl?1:-1)); });
  }
  function closeLB(){ const lb=$('#lb'); if(!lb||!lb.classList.contains('is-open')) return; lb.classList.remove('is-open'); lb.setAttribute('aria-hidden','true'); document.body.style.overflow=''; $('.gal__main')?.focus(); }

  /* collection sort */
  $$('[data-sort]').forEach(s=>s.addEventListener('change',()=>{ const u=new URL(location.href); u.searchParams.set('sort_by',s.value); u.searchParams.delete('page'); location.href=u; }));

  /* ================= MOTION LAYER ================= */
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* intro once per session */
  if(root.classList.contains('intro')){
    let fin=false;
    const done = (skip)=>{ if(fin) return; fin=true; if(skip) root.classList.add('intro-skip'); root.classList.add('is-ready'); try{sessionStorage.setItem('lcn-intro','1')}catch(e){} setTimeout(()=>root.classList.remove('intro','intro-skip'), skip ? 400 : 1000); document.dispatchEvent(new Event('lcn:intro-done')); };
    setTimeout(()=>root.classList.add('is-ready'), 3300); /* hero copy rises while the aperture opens */
    setTimeout(()=>done(false), 4300);
    $('[data-intro]')?.addEventListener('click',()=>done(true));
  }

  /* header: solid after hero, hide on scroll down, show on up */
  const hdr = $('[data-hdr]');
  if(hdr){
    let lastY = scrollY, ticking=false;
    const onScroll = ()=>{
      const y = scrollY;
      hdr.classList.toggle('is-solid', y > 40);
      if(!reduce) hdr.classList.toggle('is-hidden', y > 500 && y > lastY + 4 && !document.body.style.overflow);
      if(y < lastY - 4) hdr.classList.remove('is-hidden');
      root.classList.toggle('hdr-hidden', hdr.classList.contains('is-hidden'));
      lastY = y; ticking=false;
    };
    addEventListener('scroll',()=>{ if(!ticking){ requestAnimationFrame(onScroll); ticking=true; } },{passive:true});
    onScroll();
  }

  /* split words for [data-reveal=words] */
  $$('[data-reveal=words]').forEach(el=>{
    if(el.dataset.split) return; el.dataset.split='1';
    const text = el.textContent.trim().replace(/\s+/g,' ');
    el.setAttribute('aria-label', text);
    el.innerHTML = text.split(' ').map((w,i)=>`<span class="w" aria-hidden="true"><span style="--i:${i}">${esc(w)}</span></span>`).join(' ');
    /* v125: a Latin title on an Arabic page keeps its word order (the word boxes would otherwise be laid out right-to-left) */
    if(document.dir === 'rtl' && !/[\u0600-\u06FF]/.test(text)){ const ta = getComputedStyle(el).textAlign; el.dir = 'ltr'; if(ta === 'start' || ta === 'right') el.style.textAlign = 'right'; }
  });

  /* stagger cards in grids */
  $$('.grid').forEach(g=>$$('.card',g).forEach((c,i)=>c.style.setProperty('--d', i%4)));

  /* reveal on scroll
     v90 fix: elements revealed with a clip-path mask (brand tiles, story/lookbook photos) were hidden for good,
     because the browser treats a fully clipped element as "not visible" and never reports it as intersecting.
     Masked elements are now watched through their parent instead. */
  const split = scope => $$('[data-reveal=words]',scope).forEach(el=>{
    if(el.dataset.split) return; el.dataset.split='1';
    const text = el.textContent.trim().replace(/\s+/g,' ');
    el.setAttribute('aria-label', text);
    el.innerHTML = text.split(' ').map((w,i)=>`<span class="w" aria-hidden="true"><span style="--i:${i}">${esc(w)}</span></span>`).join(' ');
    /* v125: a Latin title on an Arabic page keeps its word order (the word boxes would otherwise be laid out right-to-left) */
    if(document.dir === 'rtl' && !/[\u0600-\u06FF]/.test(text)){ const ta = getComputedStyle(el).textAlign; el.dir = 'ltr'; if(ta === 'start' || ta === 'right') el.style.textAlign = 'right'; }
  });
  const revealIn = scope => $$('[data-reveal]',scope).forEach(el=>el.classList.add('is-in'));
  const revealAll = ()=>revealIn(document);
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  let watch = el=>el.classList.add('is-in');
  if(!reduce && 'IntersectionObserver' in window){
    const kids = new WeakMap();
    const io = new IntersectionObserver(entries=>entries.forEach(en=>{
      if(!en.isIntersecting) return;
      (kids.get(en.target)||[en.target]).forEach(k=>k.classList.add('is-in'));
      io.unobserve(en.target);
    }),{rootMargin:'0px 0px -6% 0px',threshold:.08});
    watch = el=>{
      if(el.classList.contains('is-in')) return;
      const t = el.dataset.reveal==='mask' && el.parentElement ? el.parentElement : el;
      if(t!==el){ const l = kids.get(t)||[]; l.push(el); kids.set(t,l); }
      io.observe(t);
    };
  }
  const watchAll = scope => $$('[data-reveal]',scope).forEach(watch);
  if(reduce || designMode || !('IntersectionObserver' in window)){ revealAll(); }
  else{ watchAll(document); }
  window.LucernObserve = watch;

  /* Shopify theme editor re-draws sections without reloading the page: show them straight away */
  document.addEventListener('shopify:section:load',e=>{ split(e.target); revealIn(e.target); });
  document.addEventListener('shopify:block:select',e=>{ revealIn(e.target.closest('section')||document); });
  document.addEventListener('shopify:section:select',e=>{ revealIn(e.target); });

  /* parallax + hero tilt */
  if(!reduce){
    const par = $$('[data-parallax]');
    if(par.length){
      const run = ()=>{ par.forEach(im=>{ const r = im.parentElement.getBoundingClientRect(); if(r.bottom<0||r.top>innerHeight) return; const p = (r.top + r.height/2 - innerHeight/2) / innerHeight; im.style.transform = `translateY(${p * -8}%) scale(1.14)`; }); };
      addEventListener('scroll',perFrame(run),{passive:true}); run();
    }
    const ring = $('.hero .bezel__ring');
    if(ring){ const rot=()=>{ if(scrollY < innerHeight*1.2) ring.style.setProperty('--bz', (scrollY*0.12 * (document.dir==='rtl'?-1:1))+'deg'); }; addEventListener('scroll',perFrame(rot),{passive:true}); }
    const tilt = $('[data-tilt]'); const hero = $('[data-hero]');
    if(tilt && hero && matchMedia('(hover:hover)').matches){
      hero.addEventListener('mousemove',e=>{ const r = hero.getBoundingClientRect(); const x = (e.clientX - r.left)/r.width - .5, y = (e.clientY - r.top)/r.height - .5; tilt.style.transform = `perspective(1100px) rotateY(${x*7}deg) rotateX(${-y*7}deg) translate3d(${x*10}px,${y*10}px,0)`; });
      hero.addEventListener('mouseleave',()=>{ tilt.style.transform=''; });
    }
  }

  /* hero photo drifts slowly while you scroll */
  if(!reduce){
    const hp = $('.hphoto>img');
    if(hp){ const hr = ()=>{ const y=scrollY; if(y>innerHeight*1.3) return; hp.style.transform = `translate3d(0,${(y*.08).toFixed(1)}px,0) scale(${(1.04+y/innerHeight*.08).toFixed(3)})`; }; addEventListener('scroll',perFrame(hr),{passive:true}); }
  }

  /* ---- v92 scroll-driven layer: manifesto, pinned chapters, counters ---- */
  (()=>{
    const live = !reduce && !designMode;
    const clamp = (v,a=0,b=1)=>Math.min(b,Math.max(a,v));
    const items = new Set();
    let raf = 0;
    const tick = ()=>{ raf=0; items.forEach(it=>{ if(!it.el.isConnected){ items.delete(it); return; } it.update(); }); };
    const kick = ()=>{ if(!raf) raf = requestAnimationFrame(tick); };
    addEventListener('scroll',kick,{passive:true}); addEventListener('resize',kick);
    const prog = el=>{ const r = el.getBoundingClientRect(), total = r.height - innerHeight; return total>0 ? clamp(-r.top/total) : 0; };

    const initMani = el=>{
      if(el._m || !live) return; el._m = 1;
      const ls = $$('[data-ml]',el), n = ls.length; if(!n) return;
      el.classList.add('is-live');
      const last = new Array(n).fill(-1);
      const update = ()=>{
        const p = prog(el), q = clamp((p-.05)/.88)*n;
        ls.forEach((l,i)=>{ const v = Math.round(clamp(q-i)*500)/500; if(v!==last[i]){ last[i]=v; l.style.setProperty('--l',v); l.style.setProperty('--m',v>0&&v<1?1:0); } });
        el.style.setProperty('--hand',(40+p*320).toFixed(1)+'deg');
      };
      items.add({el,update}); update();
    };

    const initChap = el=>{
      if(el._c || !live || matchMedia('(max-width:760px)').matches) return; el._c = 1;   /* v129: phones get the chapters stacked, not pinned */
      const its = $$('[data-chap-it]',el), n = its.length, nEl = $('[data-chap-n]',el); if(n<2) return;
      el.classList.add('is-live');
      let cur = -1;
      const update = ()=>{
        const p = prog(el); el.style.setProperty('--p',p.toFixed(4));
        const k = Math.min(n-1,Math.floor(p*n));
        if(k!==cur){ const prev = cur; cur=k; its.forEach((it,i)=>{ it.classList.toggle('is-on',i===k); it.classList.toggle('is-prev',i===prev); }); clearTimeout(el._pt); el._pt = setTimeout(()=>its.forEach(it=>it.classList.remove('is-prev')), 1500); if(nEl) nEl.textContent = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'][k] || k+1; }
      };
      items.add({el,update}); update();
    };

    const initNums = el=>{
      if(el._n || !live || !('IntersectionObserver' in window)) return; el._n = 1;
      const run = c=>{
        const to = parseFloat(c.dataset.count); if(isNaN(to)) return;
        const t0 = performance.now(), dur = 1500 + Math.min(to,150)*6;
        const step = now=>{ const t = clamp((now-t0)/dur), e = t===1 ? 1 : 1-Math.pow(2,-10*t); c.textContent = Math.round(to*e); if(t<1) requestAnimationFrame(step); };
        c.textContent = '0'; requestAnimationFrame(step);
      };
      const io = new IntersectionObserver(es=>es.forEach(en=>{ if(en.isIntersecting){ io.unobserve(en.target); run(en.target); } }),{threshold:.6});
      $$('[data-count]',el).forEach(c=>{ if(!isNaN(parseFloat(c.dataset.count))) c.textContent = '0'; io.observe(c); });
    };

    const boot = scope=>{ $$('[data-mani]',scope).forEach(initMani); $$('[data-chap]',scope).forEach(initChap); $$('[data-nums]',scope).forEach(initNums); kick(); };
    boot(document);
    document.addEventListener('shopify:section:load',e=>boot(e.target));
  })();

  /* ---- v93 macro hero: live hands, light that follows you, zoom into the dial on scroll ---- */
  (()=>{
    const clamp = (v,a=0,b=1)=>Math.min(b,Math.max(a,v));
    const ease = t=>1-Math.pow(1-t,3);
    const cairoNow = ()=>{
      try{
        const p = new Intl.DateTimeFormat('en-GB',{timeZone:'Africa/Cairo',hour:'numeric',minute:'numeric',second:'numeric',day:'numeric',weekday:'short',hour12:false}).formatToParts(new Date());
        const g = t=>+(p.find(x=>x.type===t)||{value:0}).value;
        const wd = (p.find(x=>x.type==='weekday')||{value:''}).value.slice(0,3).toUpperCase();
        return {s:(g('hour')%24)*3600+g('minute')*60+g('second')+(Date.now()%1000)/1000, day:g('day'), dow:wd};
      }catch(e){ const d=new Date(); return {s:d.getHours()*3600+d.getMinutes()*60+d.getSeconds()+d.getMilliseconds()/1000, day:d.getDate(), dow:['SUN','MON','TUE','WED','THU','FRI','SAT'][d.getDay()]}; }
    };
    const pad = n=>String(n).padStart(2,'0');
    const init = el=>{
      if(el._mac) return; el._mac = 1;
      const q = k=>el.querySelector(`[data-mac="${k}"]`);
      const H = {h:[q('h'),q('hs')], m:[q('m'),q('ms')], s:[q('s'),q('ss')]};
      const sub = el.querySelector('[data-mac-sub]'), timeEl = el.querySelector('[data-mac-time]'), dateEl = el.querySelector('[data-mac-date]'), dowEl = el.querySelector('[data-mac-dow]');
      const zoom = el.querySelector('[data-mac-zoom]'), copy = el.querySelector('.mac__copy');
      /* v116: the scroll-pinned zoom and the 3D model are opt-in; by default the hero is a still dial whose hands tick once a second */
      const live = !reduce && !designMode && el.dataset.zoom==='1';
      if(live) el.classList.add('is-live');
      const calm = !live && el.dataset.gl3d!=='1';
      const lite = calm || matchMedia('(max-width:900px)').matches || matchMedia('(pointer:coarse)').matches || (navigator.hardwareConcurrency && navigator.hardwareConcurrency<=2);
      if(lite) el.classList.add('is-lite');
      let base = cairoNow(), t0 = performance.now(), lastSync = t0;
      if(dateEl) dateEl.textContent = base.day;
      if(dowEl && base.dow) dowEl.textContent = base.dow;
      const rot = (pair,a)=>pair.forEach(n=>n && n.setAttribute('transform',`rotate(${a.toFixed(2)})`));
      let t_start = performance.now() + 1e9;
      let mx = 62, my = 46, tx = 62, ty = 46, lastMove = 0, hovered = false;
      const rectOf = ()=>el.getBoundingClientRect();
      if(!reduce){
        addEventListener('pointermove',e=>{
          if(e.pointerType==='touch') return;
          const r = el.querySelector('.mac__pin').getBoundingClientRect();
          if(e.clientY<r.top||e.clientY>r.bottom) return;
          tx = (e.clientX-r.left)/r.width*100; ty = (e.clientY-r.top)/r.height*100; lastMove = performance.now(); hovered = true;
        },{passive:true});
      }
      /* intro hand-off: the hands and the 3D watch start moving when the black curtain lifts */
      const html = document.documentElement;
      const glCanvas = el.querySelector('[data-mac-gl]');
      let released = false, glApi = null, tries = 0, started = false, glSince = 0;
      const whenCurtainGone = cb=>{
        if(!html.classList.contains('intro') || html.classList.contains('is-ready')) return cb();
        let fired = false; const go = ()=>{ if(fired) return; fired = true; cb(); };
        document.addEventListener('lcn:intro-done',go,{once:true}); setTimeout(go,3000);
      };
      const start = ()=>{ if(started) return; started = true; t_start = performance.now() + 100; if(glApi && glApi.state.ready) glApi.playIntro(); };
      const release = ()=>{ if(released) return; released = true; whenCurtainGone(start); };
      const conn = navigator.connection || {};
      const wantGL = glCanvas && el.dataset.gl3d==='1' && !reduce && !matchMedia('(max-width:900px),(pointer:coarse)').matches && !conn.saveData && !/(^|-)2g$/.test(conn.effectiveType||'') && !(navigator.deviceMemory && navigator.deviceMemory<=2);
      const loadGL = ()=>new Promise((res,rej)=>{
        if(window.LucernWatch) return res();
        const src = el.dataset.glJs; if(!src) return rej();
        const s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s);
      });
      const boot3d = ()=>{
        loadGL().then(()=>window.LucernWatch.start({canvas:glCanvas,container:el.querySelector('.mac__pin'),dataSrc:el.dataset.glData})).then(a=>{
          glApi = a;
          if(a.state.failed){ release(); return; }
          const ok = ()=>{ el.classList.add('has-gl'); glSince = performance.now(); if(started) a.playIntro(); release(); };
          a.state.ready ? ok() : (a.onReady = ok);
        }).catch(()=>release());
      };
      setTimeout(release,2400);
      if(wantGL){
        /* start downloading the model now (network only), but run the heavy parse/GL setup once the intro logo has played,
           so the opening animation is never competing with it for the main thread */
        const d = el.dataset.glData||'';
        [el.dataset.glJs, d, d.replace('-1.js','-2.js'), d.replace('-1.js','-3.js')].forEach(u=>{ if(!u) return; const l = document.createElement('link'); l.rel = 'preload'; l.as = 'script'; l.href = u; document.head.appendChild(l); });
        const introOn = html.classList.contains('intro') && !html.classList.contains('is-ready');
        /* v113: the 3D parse waits until the curtain is fully gone, so the intro owns the main thread */
        introOn ? whenCurtainGone(()=>setTimeout(boot3d, 60)) : boot3d();
      } else release();
      let dirty = true, lastHand = 0; const vars = {};
      addEventListener('scroll',()=>{ dirty = true; },{passive:true}); addEventListener('resize',()=>{ dirty = true; });
      /* calm hero: after the opening sweep, wake once per second (a real quartz tick) instead of every frame */
      const next = animating=>{ if((calm || (lite && el._css && !live)) && !animating && !glApi) setTimeout(()=>requestAnimationFrame(frame), 1005 - (Date.now() % 1000)); else requestAnimationFrame(frame); };
      const frame = now=>{
        if(!el.isConnected) return;
        const animating = now < t_start + 2800;
        if(lite && !glApi && !dirty && !animating && now-lastHand < 40){ next(animating); return; }
        const r = rectOf(), visible = r.bottom>0 && r.top<innerHeight;
        if(visible){
          if(now-lastSync>60000){ base = cairoNow(); t0 = now; lastSync = now; if(dateEl) dateEl.textContent = base.day; if(dowEl && base.dow) dowEl.textContent = base.dow; }
          const glOn = glSince && now-glSince>1500;   /* 3D has taken over: the hidden 2D hands need no work */
          if(glOn && !el._glLive){ el._glLive = 1; el.classList.add('gl-live'); }
          if(!lite || animating || now-lastHand>=40 || glOn){
            if(!glOn || now-lastHand>=1000 || animating){
              lastHand = now;
              const secs = base.s + (now-t0)/1000;
              if(!glOn && !el._css){
                const k = reduce ? 1 : clamp((now-t_start)/2600), e = ease(k), spin = 1-e;
                rot(H.h, (secs/3600%12)*30 - spin*120);
                rot(H.m, (secs/60%60)*6 - spin*720);
                const sa = (secs%60)*6; rot(H.s, sa - spin*1440);
                if(sub) sub.setAttribute('transform',`rotate(${(sa*1).toFixed(2)})`);
              }
              if(timeEl){ const x=Math.floor(secs); timeEl.textContent = `${pad(Math.floor(x/3600)%12||12)}:${pad(Math.floor(x/60)%60)}:${pad(x%60)}`; }
            }
          }
          /* v129: once the opening sweep is over, the hands are handed to CSS animations (no per-frame DOM writes; phones
             and session-recording scripts on the store were overwhelmed by thousands of attribute changes a minute) */
          if(!animating && !el._css && !glOn && now > t_start){
            el._css = 1;
            const secs = base.s + (now-t0)/1000;
            const hand = (pair, period, phase, steps)=>pair.forEach(n=>{ if(!n) return; n.removeAttribute('transform'); n.style.animation = `macSpin ${period}s ${steps ? 'steps('+steps+')' : 'linear'} ${-(phase % period).toFixed(2)}s infinite`; });
            hand(H.h, 43200, secs % 43200); hand(H.m, 3600, secs % 3600); hand(H.s, 60, Math.floor(secs % 60), 60);
            if(sub){ sub.removeAttribute('transform'); sub.style.animation = `macSpin 60s steps(60) ${-Math.floor(secs % 60)}s infinite`; }
          }
          if(!reduce && (!lite || glApi)){
            const idle = now-lastMove>3500 || !hovered;
            if(idle){ const t=now/1000; tx = 58+Math.cos(t*.35)*20; ty = 48+Math.sin(t*.27)*20; }
            mx += (tx-mx)*.07; my += (ty-my)*.07;
            if(!glOn){ el.style.setProperty('--mx',mx.toFixed(2)+'%'); el.style.setProperty('--my',my.toFixed(2)+'%'); }
          }
          if(live && (dirty || !lite)){
            const total = r.height-innerHeight, p = total>0 ? clamp(-r.top/total) : 0;
            const sv = (k,v)=>{ if(vars[k]!==v){ vars[k]=v; el.style.setProperty(k,v); } };
            sv('--s',(1+ease(p)*1.25).toFixed(4));
            sv('--r',(p*-7).toFixed(3)+'deg');
            sv('--f',Math.pow(clamp((p-.55)/.45),1.4).toFixed(3));
            sv('--cp',clamp(p/.55).toFixed(3));
            if(glApi) glApi.state.p = p;
          }
          if(glApi){ glApi.state.mx = mx/100; glApi.state.my = my/100; }
        }
        dirty = false;
        next(animating);
      };
      requestAnimationFrame(frame);
    };
    $$('[data-macro]').forEach(init);
    document.addEventListener('shopify:section:load',e=>$$('[data-macro]',e.target).forEach(init));
  })();

  /* watch finder: instant filters with FLIP */
  $$('[data-finder]').forEach(sec=>{
    const grid = $('[data-finder-grid]',sec), cards = $$('.card',grid), pills = $$('.pill',sec), empty = $('[data-finder-empty]',sec), count = $('[data-finder-count]',sec);
    const setCount = n=>{ if(count) count.textContent = `(${n})`; };
    setCount(cards.length);
    const match = (c,f)=>{
      if(f==='all') return true;
      const [k,v] = [f.slice(0,1), f.slice(2)];
      if(k==='v') return c.dataset.vendor===v;
      if(k==='t') return (' '+c.dataset.tags+' ').includes(' '+v) || c.dataset.tags.split(/,\s*|\s+/).includes(v);
      if(k==='p') return (+c.dataset.price) < (+v);
      return true;
    };
    pills.forEach(p=>p.addEventListener('click',()=>{
      pills.forEach(x=>x.setAttribute('aria-pressed', x===p)); const f = p.dataset.f;
      const first = new Map(cards.map(c=>[c,c.getBoundingClientRect()]));
      let n=0;
      cards.forEach(c=>{ const ok = match(c,f); c.classList.toggle('is-out',!ok); if(ok){ n++; c.classList.add('is-in'); } });
      setCount(n); if(empty) empty.hidden = n>0;
      if(reduce) return;
      cards.forEach(c=>{
        if(c.classList.contains('is-out')) return;
        const a = first.get(c), b = c.getBoundingClientRect();
        const wasHidden = a.width===0;
        if(wasHidden){ c.animate([{opacity:0,transform:'scale(.94)'},{opacity:1,transform:'none'}],{duration:450,easing:'cubic-bezier(.16,1,.3,1)'}); return; }
        const dx = a.left-b.left, dy = a.top-b.top; if(!dx && !dy) return;
        c.animate([{transform:`translate(${dx}px,${dy}px)`},{transform:'none'}],{duration:600,easing:'cubic-bezier(.16,1,.3,1)'});
      });
    }));
  });

  /* search overlay with predictive results */
  const so = $('#search-overlay');
  if(so){
    const input = $('[data-so-input]',so), res = $('[data-so-results]',so), quick = $('[data-so-quick]',so);
    let opener=null, timer=null, ctrl=null;
    const open = e=>{ e&&e.preventDefault(); opener=document.activeElement; so.classList.add('is-open'); so.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; setTimeout(()=>input.focus(),80); };
    const close = ()=>{ if(!so.classList.contains('is-open')) return; so.classList.remove('is-open'); so.setAttribute('aria-hidden','true'); document.body.style.overflow=''; opener?.focus(); };
    window.LucernCloseSearch = close;
    $$('[data-search-open]').forEach(a=>a.addEventListener('click',open));
    $$('[data-search-close]',so).forEach(b=>b.addEventListener('click',close));
    input.addEventListener('input',()=>{
      clearTimeout(timer); const q = input.value.trim();
      if(!q){ res.innerHTML=''; quick.hidden=false; return; }
      timer = setTimeout(async ()=>{
        ctrl?.abort(); ctrl = new AbortController();
        try{
          const r = await fetch(`${L.routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`,{signal:ctrl.signal}).then(r=>r.json());
          const items = r.resources?.results?.products || [];
          quick.hidden = true;
          if(!items.length){ res.innerHTML = `<p class="empty">${esc(S.noResults)}</p>`; return; }
          res.innerHTML = `<div class="grid">${items.map((p,i)=>`
            <a class="card" href="${p.url}" style="--i:${i}">
              <div class="card__media">${p.image?`<img src="${imgSize(p.image,600)}" alt="${esc(p.title)}" loading="lazy">`:''}</div>
              <div class="card__info"><p class="card__vendor">${esc(p.vendor||'')}</p><h3 class="card__title">${esc(L.titles?.[p.id]||p.title)}</h3><div class="price"><span>${money(Math.round(parseFloat(p.price)*100))}</span></div></div>
            </a>`).join('')}</div>
            <p class="so__all"><a class="link" href="${L.searchUrl}?type=product&q=${encodeURIComponent(q)}">${esc(S.viewAll)}</a></p>`;
        }catch(err){ if(err.name!=='AbortError') res.innerHTML=''; }
      }, 180);
    });
  }

  /* ================= FEATURES LAYER ================= */
  const store = {
    get(k){ try{ return JSON.parse(localStorage.getItem(k)) || []; }catch(e){ return []; } },
    set(k,v){ try{ localStorage.setItem(k, JSON.stringify(v)); }catch(e){} }
  };
  const root_ = (L.routes && L.routes.root) || '/';
  const cardCache = {}, dataCache = {};
  const fetchCard = h => cardCache[h] || (cardCache[h] = fetch(`${root_}products/${encodeURIComponent(h)}?view=card`).then(r=>r.ok?r.text():'' ).catch(()=>''));
  const fetchData = h => dataCache[h] || (dataCache[h] = fetch(`${root_}products/${encodeURIComponent(h)}?view=data`).then(r=>r.ok?r.json():null).catch(()=>null));
  function hydrate(scope){
    $$('[data-reveal]',scope).forEach(el=>el.classList.add('is-in'));
    syncFav(scope); syncCmp(scope);
  }

  /* ---- hero clock: real Cairo time ---- */
  const clock = $('[data-clock]');
  if(clock){
    const label = $('[data-clock-label]');
    const hH = $('.hand-h',clock), hM = $('.hand-m',clock), sw = $('.sweep',clock);
    const fmt = new Intl.DateTimeFormat('en-GB',{timeZone:'Africa/Cairo',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false});
    const tick = ()=>{
      const parts = Object.fromEntries(fmt.formatToParts(new Date()).map(p=>[p.type,p.value]));
      const h = (+parts.hour)%12, m = +parts.minute, sec = +parts.second;
      hH.style.transform = `rotate(${h*30 + m*.5}deg)`;
      hM.style.transform = `rotate(${m*6 + sec*.1}deg)`;
      if(label){ const hh = String(+parts.hour%12 || 12); label.textContent = `${S.cairo || 'Cairo'}  ${hh}:${parts.minute}`; }
      return sec;
    };
    const sec = tick();
    if(sw){ sw.style.animationDelay = `-${sec + new Date().getMilliseconds()/1000}s`; }
    setInterval(tick, 10000);
  }

  /* ---- wishlist ---- */
  const FAV='lcn-fav';
  function syncFav(scope=document){
    const list = store.get(FAV);
    $$('[data-fav]',scope).forEach(b=>{ const on = list.includes(b.dataset.fav); b.setAttribute('aria-pressed',on); });
    $$('.fav-count').forEach(c=>{ c.textContent = list.length; c.hidden = !list.length; });
    $$('.fav-count-inline').forEach(c=>c.textContent = list.length ? `(${list.length})` : '');
  }
  document.addEventListener('click',e=>{
    const b = e.target.closest('[data-fav]'); if(!b) return;
    e.preventDefault();
    let list = store.get(FAV); const h = b.dataset.fav;
    const adding = !list.includes(h);
    list = adding ? [h, ...list] : list.filter(x=>x!==h);
    store.set(FAV,list); syncFav();
    if(adding){ navigator.vibrate?.(8); b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); toast(S.favAdded); }
    if(!adding && b.closest('#fav-drawer')) renderFav();
  });
  const favDrawer = $('#fav-drawer');
  async function renderFav(){
    const box = $('[data-fav-list]',favDrawer); const list = store.get(FAV);
    if(!list.length){ box.innerHTML = `<p class="empty" style="grid-column:1/-1">${esc(S.favEmpty)}</p>`; return; }
    const html = await Promise.all(list.map(fetchCard));
    box.innerHTML = html.join(''); hydrate(box);
  }
  $$('[data-fav-open]').forEach(b=>b.addEventListener('click',async ()=>{
    if(!favDrawer) return; await renderFav();
    favDrawer.classList.add('is-open'); favDrawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
    setTimeout(()=>$('[data-fav-close].icon-btn',favDrawer)?.focus(),60);
  }));
  const closeFav = ()=>{ if(!favDrawer?.classList.contains('is-open')) return; favDrawer.classList.remove('is-open'); favDrawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; };
  $$('[data-fav-close]').forEach(b=>b.addEventListener('click',closeFav));
  syncFav();

  /* ---- compare ---- */
  const CMP='lcn-cmp', bar=$('#cmpbar'), cmpv=$('#cmpv');
  function syncCmp(scope=document){
    const list = store.get(CMP);
    $$('[data-cmp]',scope).forEach(b=>b.setAttribute('aria-pressed', list.includes(b.dataset.cmp)));
  }
  async function renderBar(){
    if(!bar) return; const list = store.get(CMP);
    bar.hidden = !list.length; requestAnimationFrame(()=>bar.classList.toggle('is-shown', list.length>0));
    const slots = $('[data-cmp-slots]',bar);
    const data = await Promise.all(list.map(fetchData));
    let html = data.map((d,i)=>`<div class="cmpbar__slot">${d&&d.image?`<img src="${d.image}" alt="${esc(d.title)}">`:''}<button type="button" data-cmp-rm="${esc(list[i])}" aria-label="${esc(S.remove)}">×</button></div>`).join('');
    for(let i=list.length;i<3;i++) html += `<div class="cmpbar__slot is-empty"></div>`;
    slots.innerHTML = html;
  }
  function setCmp(list){ store.set(CMP,list); syncCmp(); renderBar(); }
  document.addEventListener('click',e=>{
    const b = e.target.closest('[data-cmp]'); if(b){
      e.preventDefault(); let list = store.get(CMP); const h=b.dataset.cmp;
      if(list.includes(h)) list = list.filter(x=>x!==h);
      else { if(list.length>=3){ toast(S.cmpMax); return; } list.push(h); }
      setCmp(list); return;
    }
    const rm = e.target.closest('[data-cmp-rm]'); if(rm){ setCmp(store.get(CMP).filter(x=>x!==rm.dataset.cmpRm)); }
  });
  $('[data-cmp-clear]')?.addEventListener('click',()=>setCmp([]));
  $('[data-cmp-open]')?.addEventListener('click',async ()=>{
    const list = store.get(CMP); if(list.length<2){ toast(S.cmpNeed); return; }
    const data = (await Promise.all(list.map(fetchData))).filter(Boolean);
    const n = data.length;
    const row = (k, cells, cls='') => `<div class="k">${k}</div>` + cells.map(c=>`<div class="${cls}">${c}</div>`).join('');
    const html = `<div class="cmpt" style="--n:${n}">`
      + `<div class="k"></div>` + data.map(d=>`<a class="im" href="${d.url}">${d.image?`<img src="${d.image}" alt="">`:''}</a>`).join('')
      + row('', data.map(d=>`<a href="${d.url}">${esc(d.title)}</a>`),'t')
      + row(esc(S.cmpBrand), data.map(d=>esc(d.vendor)))
      + row(esc(S.cmpPrice), data.map(d=>`<strong>${d.price}</strong>`))
      + row(esc(S.cmpStyle), data.map(d=>esc(d.styles||'—')))
      + row(esc(S.cmpOrig), data.map(d=>d.original?esc(S.yes):'—'))
      + row(esc(S.cmpAvail), data.map(d=>d.available?esc(S.inStock):esc(S.soldOut)))
      + row('', data.map(d=> d.available && d.single
          ? `<form data-atc><input type="hidden" name="id" value="${d.variant}"><input type="hidden" name="quantity" value="1"><button class="btn btn--solid" type="submit">${esc(S.addToCartShort)}</button></form>`
          : `<a class="btn btn--ghost" href="${d.url}">${esc(S.view)}</a>`))
      + `</div>`;
    $('[data-cmp-table]',cmpv).innerHTML = html;
    cmpv.classList.add('is-open'); cmpv.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
    $('[data-cmp-close]',cmpv).focus();
  });
  const closeCmp = ()=>{ if(!cmpv?.classList.contains('is-open')) return; cmpv.classList.remove('is-open'); cmpv.setAttribute('aria-hidden','true'); document.body.style.overflow=''; };
  $('[data-cmp-close]')?.addEventListener('click',closeCmp);
  document.addEventListener('keydown',e=>{ if(e.key==='Escape'){ closeFav(); closeCmp(); } });
  // close compare view when adding to cart from it (drawer opens)
  cmpv?.addEventListener('submit',()=>setTimeout(closeCmp,50));
  syncCmp(); renderBar();

  /* ---- recently viewed ---- */
  const RV='lcn-rv', pdpEl = $('[data-pdp]');
  if(pdpEl){
    const h = pdpEl.dataset.handle; let list = store.get(RV).filter(x=>x!==h);
    const others = list.slice(0,4);
    store.set(RV,[h,...list].slice(0,10));
    const sec = $('[data-rv]');
    if(sec && others.length){
      Promise.all(others.map(fetchCard)).then(html=>{
        const g = $('[data-rv-grid]',sec); g.innerHTML = html.join(''); if(!g.children.length) return;
        sec.hidden=false; hydrate(sec);
      });
    }
  }

  /* ---- loupe + hotspots ---- */
  const gmain = $('.gal__main');
  if(gmain){
    const loupe = $('[data-loupe]',gmain), hs = $('[data-hs]',gmain);
    document.addEventListener('lucern:slide',e=>{ hs && hs.classList.toggle('is-on', e.detail===0); });
    if(hs){
      $$('.hs__dot',hs).forEach(d=>d.addEventListener('click',ev=>{
        ev.stopPropagation(); const pt = d.parentElement; const open = !pt.classList.contains('is-open');
        $$('.hs__pt',hs).forEach(x=>{x.classList.remove('is-open'); $('.hs__dot',x).setAttribute('aria-expanded','false');});
        if(open){ pt.classList.add('is-open'); d.setAttribute('aria-expanded','true'); }
      }));
      document.addEventListener('click',e=>{ if(!e.target.closest('.hs__pt')) $$('.hs__pt',hs).forEach(x=>x.classList.remove('is-open')); });
    }
    if(loupe && matchMedia('(hover:hover) and (pointer:fine)').matches){
      const Z=2.6, SZ=190;
      gmain.addEventListener('mousemove',e=>{
        const img = $('img.is-active',gmain);
        if(!img || !img.naturalWidth || e.target.closest('.hs__pt')){ loupe.classList.remove('is-on'); gmain.classList.remove('has-loupe'); return; }
        const r = gmain.getBoundingClientRect(); const pad = r.width*.06;
        const bw = r.width-2*pad, bh = r.height-2*pad, ar = img.naturalWidth/img.naturalHeight;
        let dw=bw, dh=bw/ar; if(dh>bh){ dh=bh; dw=bh*ar; }
        const ox = pad+(bw-dw)/2, oy = pad+(bh-dh)/2;
        const x = e.clientX-r.left, y = e.clientY-r.top, u=(x-ox)/dw, v=(y-oy)/dh;
        if(u<0||u>1||v<0||v>1){ loupe.classList.remove('is-on'); gmain.classList.remove('has-loupe'); return; }
        const src = img.dataset.zoom || img.currentSrc;
        if(loupe.dataset.src!==src){ loupe.style.backgroundImage=`url("${src}")`; loupe.dataset.src=src; }
        loupe.style.backgroundSize = `${dw*Z}px ${dh*Z}px`;
        loupe.style.backgroundPosition = `${-(u*dw*Z - SZ/2)}px ${-(v*dh*Z - SZ/2)}px`;
        loupe.style.left = x+'px'; loupe.style.top = y+'px';
        loupe.classList.add('is-on'); gmain.classList.add('has-loupe');
      });
      gmain.addEventListener('mouseleave',()=>{ loupe.classList.remove('is-on'); gmain.classList.remove('has-loupe'); });
    }
  }

  /* ---- delivery estimate ---- */
  const eta = $('[data-eta]');
  if(eta){
    const sel = $('select',eta), out = $('[data-eta-out]',eta);
    const upd = ()=>{
      const opt = sel.selectedOptions[0]; const z = opt && opt.dataset.zone;
      const days = z ? eta.dataset['z'+z] : '';
      const fee = z ? eta.dataset['f'+z] : '';
      out.innerHTML = days ? esc(eta.dataset.tpl).replace('__D__',`<strong>${esc(days)}</strong>`) + (fee ? ' · ' + esc(eta.dataset.feeTpl||'__F__').replace('__F__',`<strong>${esc(fee)}</strong>`) : '') : '';
      try{ localStorage.setItem('lcn-gov', sel.value); }catch(e){}
    };
    try{ const g = localStorage.getItem('lcn-gov'); if(g) sel.value = g; }catch(e){}
    sel.addEventListener('change',upd); upd();
  }

  /* ---- gift mode ---- */
  let giftT = null;
  async function saveGift(box, toggled){
    const on = $('[data-gift-on]',box).checked;
    const attrs = { 'Gift': on ? 'Yes' : '', 'Gift message': on ? $('[data-gift-msg]',box).value.trim() : '', 'Hide prices': on && $('[data-gift-hide]',box).checked ? 'Yes' : '' };
    await fetch(`${root_}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:attrs})});
    if(toggled && L.giftWrap){
      const cart = await fetch(`${root_}cart.js`).then(r=>r.json());
      const has = cart.items.find(i=>i.variant_id===L.giftWrap);
      if(on && !has) await fetch(`${root_}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:L.giftWrap,quantity:1}]})});
      if(!on && has) await fetch(`${root_}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:has.key,quantity:0})});
      if($('form[data-cart-form]')) location.reload(); else renderCart();
    }
  }
  document.addEventListener('change',e=>{
    const box = e.target.closest('[data-gift]'); if(!box) return;
    if(e.target.matches('[data-gift-on]')){
      $$('[data-gift]').forEach(b=>{ b.classList.toggle('is-on', e.target.checked); $('[data-gift-on]',b).checked = e.target.checked; });
      saveGift(box,true);
    } else saveGift(box,false);
  });
  document.addEventListener('input',e=>{
    if(!e.target.matches('[data-gift-msg]')) return;
    const box = e.target.closest('[data-gift]'); $$('[data-gift-msg]').forEach(t=>{ if(t!==e.target) t.value = e.target.value; });
    clearTimeout(giftT); giftT = setTimeout(()=>saveGift(box,false),500);
  });

  /* ---- welcome offer ---- */
  const offer = $('#offer');
  if(offer){
    let dismissed = 0; try{ dismissed = +localStorage.getItem('lcn-offer-x') || 0; }catch(e){}
    const fresh = Date.now() - dismissed > 14*864e5;
    if(fresh && !/\/(cart|checkouts?)/.test(location.pathname)){
      setTimeout(()=>{ offer.hidden=false; requestAnimationFrame(()=>requestAnimationFrame(()=>offer.classList.add('is-shown'))); }, (+offer.dataset.delay||20)*1000);
    }
    $('[data-offer-close]',offer).addEventListener('click',()=>{ offer.classList.remove('is-shown'); setTimeout(()=>offer.hidden=true,500); try{ localStorage.setItem('lcn-offer-x', Date.now()); }catch(e){} });
    $('[data-offer-copy]',offer).addEventListener('click',async ev=>{
      const b = ev.currentTarget; try{ await navigator.clipboard.writeText(b.dataset.offerCopy); }catch(e){}
      $('[data-copy-label]',b).textContent = S.copied;
    });
  }

  /* ================= MOBILE LAYER ================= */
  /* share */
  $$('[data-share]').forEach(b=>b.addEventListener('click',async ()=>{
    const data = {title:b.dataset.title, url:b.dataset.url};
    if(navigator.share){ try{ await navigator.share(data); }catch(e){} return; }
    try{ await navigator.clipboard.writeText(data.url); toast(S.linkCopied); }catch(e){}
  }));

  /* generic sheets (bottom sheets on phones) */
  const openSheet = el=>{ el.classList.add('is-open'); el.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; setTimeout(()=>$('.drawer__hd .icon-btn',el)?.focus(),60); };
  const closeSheet = el=>{ el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); document.body.style.overflow=''; el.querySelector('.drawer__panel').style.transform=''; };
  $$('[data-sheet-open]').forEach(b=>b.addEventListener('click',()=>{ const el = $('#sheet-'+b.dataset.sheetOpen); el && openSheet(el); }));
  $$('.sheet').forEach(sh=>$$('[data-sheet-close]',sh).forEach(b=>b.addEventListener('click',()=>closeSheet(sh))));
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') $$('.sheet.is-open').forEach(closeSheet); });
  $$('[data-sort-val]').forEach(b=>b.addEventListener('click',()=>{ const u=new URL(location.href); u.searchParams.set('sort_by',b.dataset.sortVal); u.searchParams.delete('page'); location.href=u; }));

  /* swipe down to close any drawer on phones */
  const phone = matchMedia('(max-width:699px)');
  $$('.drawer').forEach(dr=>{
    const panel = $('.drawer__panel',dr), hd = $('.drawer__hd',dr); if(!panel||!hd) return;
    let y0=null, dy=0;
    hd.addEventListener('touchstart',e=>{ if(!phone.matches) return; y0=e.touches[0].clientY; dy=0; panel.style.transition='none'; },{passive:true});
    hd.addEventListener('touchmove',e=>{ if(y0===null) return; dy=Math.max(0,e.touches[0].clientY-y0); panel.style.transform=`translateY(${dy}px)`; },{passive:true});
    hd.addEventListener('touchend',()=>{ if(y0===null) return; panel.style.transition=''; panel.style.transform=''; y0=null;
      if(dy>90){ const x = $('[data-drawer-close],[data-fav-close],[data-sheet-close]',dr); x ? x.click() : closeSheet(dr); } });
  });

  /* collection: 1 or 2 per row on phones */
  const cg = $('[data-coll-grid]');
  if(cg){
    const apply = n=>{ cg.classList.toggle('grid--one', n==='1'); $$('[data-cols]').forEach(b=>b.setAttribute('aria-pressed', b.dataset.cols===n)); };
    let saved='2'; try{ saved = localStorage.getItem('lcn-cols') || '2'; }catch(e){}
    apply(saved);
    $$('[data-cols]').forEach(b=>b.addEventListener('click',()=>{ apply(b.dataset.cols); try{ localStorage.setItem('lcn-cols',b.dataset.cols); }catch(e){} }));
  }

  /* tab bar: hide on scroll down, show on up */
  const tb = $('[data-tabbar]');
  if(tb){
    let ly = scrollY, tk=false;
    addEventListener('scroll',()=>{ if(tk) return; tk=true; requestAnimationFrame(()=>{ const y=scrollY; if(y>ly+6 && y>200) tb.classList.add('is-hidden'); else if(y<ly-6) tb.classList.remove('is-hidden'); ly=y; tk=false; }); },{passive:true});
  }

  /* smooth inertia scroll (mouse wheel / trackpad). Touch keeps native momentum. */
  (function smoothScroll(){
    /* v116: off. Native scrolling is smoother and never fights the browser; this hijacked every wheel event. */
    if(true) return;
    const mq = q=>matchMedia(q).matches;
    if(!mq('(pointer:fine)') || mq('(prefers-reduced-motion:reduce)') || (window.Shopify && Shopify.designMode)) return;
    const root = document.documentElement;
    root.classList.add('lcn-smooth');
    let cur = scrollY, target = scrollY, raf = 0, last = 0, own = false;
    const max = ()=>Math.max(0, root.scrollHeight - innerHeight);
    const clamp = v=>Math.min(max(), Math.max(0, v));
    const locked = ()=> document.body.style.overflow==='hidden';
    const scrollable = el=>{
      for(let n=el; n && n!==document.body && n!==root; n=n.parentElement){
        const cs = getComputedStyle(n), oy = cs.overflowY;
        if((oy==='auto'||oy==='scroll') && n.scrollHeight > n.clientHeight+1) return true;
        if(n.tagName==='TEXTAREA' || n.tagName==='SELECT') return true;
      }
      return false;
    };
    const tick = t=>{
      const dt = Math.min(48, t-(last||t)); last = t;
      const k = 1 - Math.pow(0.0015, dt/1000);   /* frame-rate independent ease */
      cur += (target-cur)*k;
      if(Math.abs(target-cur) < .4){ cur = target; raf = 0; last = 0; }
      own = true; scrollTo(0, cur); 
      if(raf) raf = requestAnimationFrame(tick);
    };
    const go = ()=>{ if(!raf){ last = 0; raf = requestAnimationFrame(tick); } };
    addEventListener('wheel', e=>{
      if(e.ctrlKey || e.defaultPrevented || e.deltaY===0 || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      if(locked() || scrollable(e.target)) return;
      e.preventDefault();
      const d = e.deltaMode===1 ? e.deltaY*34 : e.deltaMode===2 ? e.deltaY*innerHeight : e.deltaY;
      target = clamp((raf ? target : scrollY) + d);
      go();
    }, {passive:false});
    /* external scroll (scrollbar drag, keyboard, find, anchors): resync */
    addEventListener('scroll', ()=>{ if(own){ own = false; return; } if(!raf){ cur = target = scrollY; } }, {passive:true});
    addEventListener('keydown', e=>{ if(raf && /^(Arrow|Page|Home|End| )/.test(e.key)){ cancelAnimationFrame(raf); raf = 0; cur = target = scrollY; } });
    addEventListener('resize', ()=>{ if(!raf) cur = target = scrollY; });
    /* in-page anchors glide with the same easing */
    document.addEventListener('click', e=>{
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if(!a || a.getAttribute('href').length<2 || e.defaultPrevented) return;
      const el = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if(!el) return;
      e.preventDefault(); cur = scrollY;
      target = clamp(el.getBoundingClientRect().top + scrollY - 80); go();
    });
  })();
})();

/* v128 · product page: "How to tell it's original" opens and shows the authenticity notes; the wrist size is shared with the fitting */
(()=>{
  document.addEventListener('click', e=>{
    const b = e.target.closest && e.target.closest('[data-open-acc]'); if(!b) return;
    const d = document.querySelector(`[data-acc="${b.dataset.openAcc}"]`); if(!d) return;
    d.open = true; d.scrollIntoView({ behavior:'smooth', block:'center' });
  });
  const f = document.querySelector('[data-wrist-field]'); if(!f) return;
  const cmUnit = f.dataset.unit || 'cm';
  try{ const v = localStorage.getItem('lcn-wrist'); if(v) f.value = v + ' ' + cmUnit; }catch(e){}
  f.addEventListener('change', ()=>{
    const n = parseFloat(f.value.replace(/[٠-٩]/g, d=>'٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(',', '.'));
    if(n >= 12 && n <= 25){ try{ localStorage.setItem('lcn-wrist', n); }catch(e){} document.dispatchEvent(new CustomEvent('lucern:wrist', { detail:n })); }
  });
  document.addEventListener('lucern:wrist', e=>{ if(document.activeElement !== f) f.value = e.detail + ' ' + cmUnit; });
})();
